/**
 * Manual light/dark theme preference (Sprint 056). Tailwind v4 has no config
 * file here, so the `dark:` variant is wired to a `.dark` class on `<html>`
 * via `@custom-variant dark` in `index.css` — this module owns reading and
 * writing the persisted choice. `localStorage` can throw (Safari private
 * mode, storage disabled); every op is best-effort, matching the pattern in
 * `active-batch-store.ts`.
 */
export type Theme = 'light' | 'dark'

const KEY = 'bainner_theme'

export function getStoredTheme(): Theme {
  try {
    return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light'
  } catch {
    return 'light'
  }
}

export function applyTheme(theme: Theme): void {
  document.documentElement.classList.toggle('dark', theme === 'dark')
  try {
    localStorage.setItem(KEY, theme)
  } catch {
    /* best-effort — theme still applies for this session even if persistence fails */
  }
}
